module.exports = __webpack_public_path__ + "img/ico_sjlz.ef283706.png";